import { createAsyncThunk } from '@reduxjs/toolkit';
// api
import departmentsApi from '../../../api/departmentsApi';
import tobaccoTransactionsApi from '../../../api/tobaccoTransactionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'tobaccoTransactions';

export const GetTobaccoTransactions = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getTobaccoTransactions`,
  async (params, thunkAPI) => {
    // params.startDate = dayjs(params.startDate).format('YYYY-MM-DD');
    // params.endDate = dayjs(params.endDate).format('YYYY-MM-DD');

    const res = await tobaccoTransactionsApi.get(params);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetDepartments = createAsyncThunk(`${REDUCER_NAME}/getDepartments`, async (___, thunkAPI) => {
  const res = await departmentsApi.get();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
